<template>
  <div>
    <v-dialog v-model="showShouldRegisterDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline"> تسجيل الدخول </v-card-title>
        <v-card-text>
          يجب أن تقوم بتسجيل الدخول إلى الموقع أو انشاء حساب جديد في حال لم يكن
          لديك حساب حت تتمكن من الاشتراك في هذا المشروع
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="showShouldRegisterDialog = false"
          >
            تم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAddAgainDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">
          إضافة التبرع إلى السلة مرة أخرى
        </v-card-title>
        <v-card-text
          >قمت بإضافة هذا التبرع إلى السلة سابقا، هل تريد إضافته مرة أخرى؟ سيتم
          إضافة المبلغ إلى المبلغ الحالي.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="addToCart"> نعم </v-btn>
          <v-btn color="red darken-1" text @click="showAddAgainDialog = false">
            لا
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSubscribeDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">
          الاشتراك الشهري في المشروع
        </v-card-title>
        <v-card-text>
          <p>
            ستقوم بالاشتراك الشهري في مشروع
            <span style="color: #743063; font-weight: bold">{{
              itemProp.name | localized
            }}</span>
            بمبلغ
            <span style="color: #743063; font-weight: bold"
              >{{ subscriptionAmount() }} KD</span
            >
            في بداية كل شهر
          </p>
          <p>هل انت متأكد من الاشتراك؟</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirmSubscription">
            نعم
          </v-btn>
          <v-btn color="red darken-1" text @click="showSubscribeDialog = false">
            لا
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="ma-3" max-width="250" :elevation="elevation">
      <v-img
        v-if="showImage"
        @click="openItemDetail"
        height="220"
        contain
        :src="itemProp.thumbnailUrl"
      ></v-img>
      <v-card-title class="text-h5" style="color: #743063">{{
        itemProp.name | localized
      }}</v-card-title>

      <v-card-text style="color: #019891">
        <div>{{ itemProp.shortDescription | localized }}</div>
        <div v-if="itemProp.hasVariations">
          <v-select
            v-model="itemProp"
            :items="variations"
            item-text="variationOptionDisplayText.arabic"
            item-value="id"
            :label="itemProp.variationOptionLabelText.arabic"
            solo
          ></v-select>
        </div>
        <div v-if="itemProp.type === 'TargetCostDonation'">
          <v-progress-linear
            rounded
            :value="itemProp.paymentProgress * 100"
            height="25"
          >
            <strong>{{ Math.ceil(itemProp.paymentProgress * 100) }}%</strong>
          </v-progress-linear>
          <div class="d-flex justify-center mx-auto my-1">
            <v-card outlined class="mx-1">
              <v-card-text class="text-center">
                <div class="caption">قيمة المشروع</div>
                <div class="caption">{{ itemProp.cost }} KD</div>
              </v-card-text>
            </v-card>
            <v-card outlined class="mx-1">
              <v-card-text class="text-center">
                <div class="caption">المدفوع</div>
                <div class="caption">{{ itemProp.paidAmount }} KD</div>
              </v-card-text>
            </v-card>
            <v-card outlined class="mx-1">
              <v-card-text class="text-center">
                <div class="caption">المتـبـقي</div>
                <div class="caption">
                  {{ Math.ceil(itemProp.cost - itemProp.paidAmount) }} KD
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
        <div v-if="itemProp.paymentType === 'UserInputAmount'" class="mx-0">
          <h3 class="text-center">قم بادخال التبرع</h3>
          <br />
          <v-text-field
            inputmode="numeric"
            class="mx-5"
            :placeholder="`${itemProp.defaultUserInputAmount}`"
            prefix="KD"
            outlined
            v-model.number="amount"
            type="number"
          ></v-text-field>

          <div v-if="itemProp.displaySuggestedAmounts" class="text-center">
            <v-chip
              @click="useSuggestedAmount(suggestedAmount)"
              v-for="(suggestedAmount, index) in itemProp.suggestedAmounts"
              :key="index"
              class="ma-2"
            >
              {{ suggestedAmount.amount }} KD
            </v-chip>
          </div>
        </div>
        <div
          v-if="itemProp.paymentType === 'UserInputAmountWithFixedOptions'"
          class="mx-0"
        >
          <v-text-field
            inputmode="numeric"
            class="mx-5"
            :placeholder="`${itemProp.defaultUserInputAmount}`"
            prefix="KD"
            outlined
            disabled
            v-model.number="amount"
            type="number"
          ></v-text-field>

          <div v-if="itemProp.displaySuggestedAmounts" class="text-center">
            <v-chip
              @click="useSuggestedAmount(suggestedAmount)"
              v-for="(suggestedAmount, index) in itemProp.suggestedAmounts"
              :key="index"
              class="ma-2"
            >
              {{ suggestedAmount.amount }} KD
            </v-chip>
          </div>
        </div>
        <div v-if="itemProp.paymentType === 'FixedAmount'" class="mx-0">
          <h2 class="text-center">{{ itemProp.fixedDonationAmount }} KD</h2>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center">
        <div v-if="itemProp.isCommingSoon">
          {{ itemProp.commingSoonText | localized }}
        </div>
        <div v-else>
          <div v-if="itemProp.type === 'Subscription'">
            <div
              v-if="
                subscriptionLookup.subscriptionItemsLookup[`${itemProp.id}`]
              "
            >
              تم الاشتراك في المشروع
            </div>
            <v-btn
              v-else
              :loading="isSubscribing"
              rounded
              dark
              class="ma-1"
              color="#743063"
              @click="subscribeNow"
            >
              اشترك الآن
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              :loading="isAddingToCart"
              rounded
              dark
              class="ma-1"
              color="#019891"
              @click="addToCart"
            >
              أضف للسلة
            </v-btn>
            <v-btn
              :loading="isQuickDonating"
              rounded
              dark
              class="ma-1"
              color="#743063"
              @click="quickDonate"
            >
              التبرع السريع
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SmallItemComponent",

  //********************** */
  props: {
    itemProp: {
      type: Object,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    elevation: {
      type: Number,
      default: 2,
    },
    isInItemDetail: {
      type: Boolean,
      default: false,
    },
  },

  //********************** */
  components: {},

  //********************** */
  data() {
    return {
      showAddAgainDialog: false,
      showSubscribeDialog: false,
      showShouldRegisterDialog: false,
      isAddingToCart: false,
      isQuickDonating: false,
      isSubscribing: false,
      amount: null,
      quantity: 1,
      showError: false,
      rules: [(v) => v > 0 || "المبلغ يجب أن يكون أكثر من 0"],
      item: this.itemProp,
      variations: [],
    };
  },

  //********************** */
  computed: {
    ...mapGetters("Cart", {
      cart: "cart",
      cartItemsDictionary: "cartItemsDictionary",
    }),

    ...mapGetters("Subscription", {
      subscriptionLookup: "subscriptionLookup",
    }),

    ...mapGetters("Account", {
      isRegistered: "isRegistered",
    }),

    addToCartClass: function () {
      return this.cartItemsDictionary[this.item.id] == true
        ? "teal lighten-1"
        : "teal lighten-1";
    },

    toEnglishDigits: function (str) {
      var e = "۰".charCodeAt(0);
      str = str.replace(/[۰-۹]/g, function (t) {
        return t.charCodeAt(0) - e;
      });

      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      str = str.replace(/[٠-٩]/g, function (t) {
        return t.charCodeAt(0) - e;
      });
      return str;
    },
  },

  //********************** */
  methods: {
    subscribeNow: function () {
      if (this.isRegistered) {
        this.showSubscribeDialog = true;
      } else {
        this.showShouldRegisterDialog = true;
      }
    },

    subscriptionAmount: function () {
      var currentAmount = this.itemProp.defaultUserInputAmount;
      if (this.amount && this.amount > 0) {
        currentAmount = this.amount;
      }

      return currentAmount;
    },
    confirmSubscription: async function () {
      this.showSubscribeDialog = false;

      let model = {
        itemId: this.itemProp.id,
        amount: this.subscriptionAmount(),
      };

      this.isSubscribing = true;

      try {
        await this.$store.dispatch("Subscription/subscribeToItem", model);

        await this.$store.dispatch("Subscription/loadCustomerSubscriptions");
        await this.$store.dispatch("Subscription/loadUnpaidInstallments");
        await this.$store.dispatch("Subscription/loadSubscriptionLookup");
        await this.$store.dispatch("Catalog/loadSubscriptionItems");
        
        this.isSubscribing = false;
      } catch (error) {
        this.showError = true;

        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }

      this.isSubscribing = false;
    },
    useSuggestedAmount: function (suggestedAmount) {
      this.amount = suggestedAmount.amount;
    },
    openItemDetail: function () {
      if (this.isInItemDetail) {
        return;
      }
      let itemId = this.itemProp.id;
      this.$router.push({ path: `/itemDetail/${itemId}` });
    },
    quickDonate: async function () {
      this.isQuickDonating = true;
      var currentAmount = this.itemProp.defaultUserInputAmount;
      if (this.amount && this.amount > 0) {
        currentAmount = this.amount;
      }
      try {
        await this.$store.dispatch("Cart/addItem", {
          cartId: this.cart.id,
          quantity: this.quantity,
          itemId: this.itemProp.id,
          amount: currentAmount,
        });
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isQuickDonating = false;
      this.$store.dispatch("Cart/showDonate");
    },

    addToCart: async function () {
      if (
        this.showAddAgainDialog == false &&
        this.cartItemsDictionary[this.itemProp.id] == true
      ) {
        this.showAddAgainDialog = true;
        return;
      }

      this.showAddAgainDialog = false;
      this.isAddingToCart = true;
      var currentAmount = this.itemProp.defaultUserInputAmount;
      if (this.amount && this.amount > 0) {
        currentAmount = this.amount;
      }
      try {
        await this.$store.dispatch("Cart/addItem", {
          cartId: this.cart.id,
          quantity: this.quantity,
          itemId: this.itemProp.id,
          amount: currentAmount,
        });
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isAddingToCart = false;
    },
    prepareVariations: function () {
      let mainItem = {
        id: this.itemProp.id,
        thumbnailUrl: this.itemProp.thumbnailUrl,
        name: this.itemProp.name,
        shortDescription: this.itemProp.shortDescription,
        type: this.itemProp.type,
        paymentProgress: this.itemProp.paymentProgress,
        cost: this.itemProp.cost,
        paidAmount: this.itemProp.paidAmount,
        paymentType: this.itemProp.paymentType,
        defaultUserInputAmount: this.itemProp.defaultUserInputAmount,
        displaySuggestedAmounts: this.itemProp.displaySuggestedAmounts,
        suggestedAmounts: this.itemProp.suggestedAmounts,
        fixedDonationAmount: this.itemProp.fixedDonationAmount,
        isCommingSoon: this.itemProp.isCommingSoon,
        commingSoonText: this.itemProp.commingSoonText,
        variationOptionDisplayText: this.itemProp.variationOptionDisplayText,
        variationOptionLabelText: this.itemProp.variationOptionLabelText,
      };

      this.variations.push(mainItem);

      let variationItems = this.itemProp.variations.map(function (x) {
        return {
          id: x.id,
          thumbnailUrl: x.thumbnailUrl,
          name: x.name,
          shortDescription: x.shortDescription,
          type: x.type,
          paymentProgress: x.paymentProgress,
          cost: x.cost,
          paidAmount: x.paidAmount,
          paymentType: x.paymentType,
          defaultUserInputAmount: x.defaultUserInputAmount,
          displaySuggestedAmounts: x.displaySuggestedAmounts,
          suggestedAmounts: x.suggestedAmounts,
          fixedDonationAmount: x.fixedDonationAmount,
          isCommingSoon: x.isCommingSoon,
          commingSoonText: x.commingSoonText,
          variationOptionDisplayText: x.variationOptionDisplayText,
          variationOptionLabelText: x.variationOptionLabelText,
        };
      });

      this.variations.concat(variationItems);
    },
  },

  //*********************** */
  mounted() {
    //this.amount = this.item.defaultUserInputAmount;
    //console.log(this.item);
    if (this.itemProp.hasVariations) {
      this.prepareVariations();
    }
  },
};
</script>

<style>
</style>